import React from "react";
import { Position, NodeProps } from "@xyflow/react";
import { RiListUnordered } from "@remixicon/react";
import classNames from "classnames";
import BaseHandle from "../BaseHandle";
import Styles from "./Nodes.module.scss";
import { useWorkflow } from "../../providers/WorkflowProvider";
import { WorkflowStepGroup } from "../../../../__generated__/api";
import Badge from "../../../theme/badge/Badge";

export default function SubactionGroupNode(props: NodeProps) {
    const { data, id } = props;
    const { collapsedGroups } = useWorkflow();

    const childrenCount = (data?.allowedChildren as WorkflowStepGroup[])?.length ?? 0;
    const isCollapsed = collapsedGroups.has(id);

    return (
        <div
            className={classNames(Styles["actions-group-node-wrapper"], {
                nonDraggableNode: true,
            })}
        >
            <BaseHandle type="target" position={Position.Left} id="a" />
            <div
                className={classNames(Styles["base-group-node"], Styles["group-node-subaction"])}
            >
                <RiListUnordered />
                <p>Subactions</p>

                {isCollapsed && childrenCount > 0 && (
                    <Badge
                        size="small"
                        isRounded
                        className={classNames(Styles["group-node-badge-subaction"], Styles["group-node-badge"])}
                    >
                        {childrenCount}
                    </Badge>
                )}
            </div>
            <BaseHandle
                type="source"
                position={Position.Bottom}
                id="b"
            />
        </div>
    );
}
